/**
 * Rewrites previous-step reference tags like "{<oldId>.path}" to "{<newId>.path}" anywhere
 * they appear inside a JSON-serialisable value (formData, edge condition settings, etc.).
 * Used whenever a node/step identifier changes (BE UUID <-> flow-position id) so that any
 * tag referencing that step by its old identifier keeps pointing at the right step.
 */

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const remapReferenceTagsDeep = (value: unknown, idMap: Map<string, string>): unknown => {
    if (typeof value === "string") {
        let result = value;
        idMap.forEach((newId, oldId) => {
            const pattern = new RegExp(`\\{${escapeRegExp(oldId)}(\\.[^}]*)?\\}`, "g");
            result = result.replace(pattern, (_match, rest: string | undefined) => `{${newId}${rest ?? ""}}`);
        });
        return result;
    }
    if (Array.isArray(value)) {
        return value.map((item) => remapReferenceTagsDeep(item, idMap));
    }
    if (value && typeof value === "object") {
        return Object.fromEntries(
            Object.entries(value as Record<string, unknown>).map(([key, v]) => [key, remapReferenceTagsDeep(v, idMap)])
        );
    }
    return value;
};
